// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__desc--iu5Zl {\n  margin: 0 0 16px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #374151;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/dashboard/CredentialingPage/components/SignatureBackfillBanner/s.module.less"],"names":[],"mappings":"AACA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAJ","sourcesContent":["// 原型 Signatures 弹窗正文第一行\n.desc {\n    margin: 0 0 16px;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"desc": "s-module__desc--iu5Zl"
};
export default ___CSS_LOADER_EXPORT___;
